
import React, { useState, useEffect, useRef } from "react";
import Typography from "../components/Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";

import { fetchMarketStatus } from "../models/marketsService";
import { Sun, Moon } from "@phosphor-icons/react";



function MarketStatus(){
    const { theme } = useTheme(); 

    const [marketStatus, setMarketStatus] = useState(null);

    useEffect(() => {
        
            const fetchStatus = async () => {
                try {

                    const response = await fetchMarketStatus();
                    setMarketStatus(response.afterHours);
                    console.log("Market Status:", response);
        
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
        
            fetchStatus();
        }, []);  

    

    const isMarketClosed = marketStatus === true;
    const statusColor = isMarketClosed ? "#5B6CD9" : "#FDA831";
    const backgroundColor = isMarketClosed ? "rgba(91, 108, 217, 0.1)" : "#FFF8EA"; // 10% opacity
    const icon = isMarketClosed ? <Moon size={16} /> : <Sun size={16} />;
    const text = isMarketClosed ? "U.S. Markets Closed" : "U.S. Markets Open";
    


    const styles = {
        container: {
            display: "flex",
            gap: `${spacing.s}px`,
        },
        statusContainer: {
            display: "flex",
            gap: `${spacing.xs}px`,
            alignItems: "center",
            padding: `${spacing.xs}px ${spacing.xs}px`,
            color: statusColor,
            backgroundColor: backgroundColor, 
            borderRadius: borderRadius.xs,
        },
    }
   
    
    return (
        <div className="marketStatus-container" style={styles.container}>
            {marketStatus !== null ? (
                <div className="marketStatus-icon" style={styles.statusContainer}>
                    {icon}
                    <Typography variant="label" type="utility">{text}</Typography>
                </div>
            ) : (
                <Typography variant="label" type="utility">Loading...</Typography>
            )}
        </div>
    )
}

export default MarketStatus;